import React, { useEffect, useState } from "react";
import { Layout, Avatar, Dropdown, Menu, Select, message, Badge, Table, Tooltip, Button } from "antd";
import FontIcon from "../components/YhIcon";
import { useHistory } from "react-router-dom";
import useGlobalModel from "../model/globalModel";
import useNavModel from "../model/navModel";
import Logo from "@/assets/images/header-logo.png"
import { ISelectOption } from "@/components/YhFormBox/Types";
import { isArray } from "util";
import { UserOutlined, SwapOutlined } from "@ant-design/icons";
import { loginServiceAuth2 } from "@/views/login/LoginServiceAuth2";
import { closeWebPage } from "@/utils/utils";
import { CLIENT_APP_CODE } from "@/utils/constants";

const { Header } = Layout;

function ScmHeader() {
    const history = useHistory();
    const { user, setUser, curentUser, setCurentUser } = useGlobalModel();
    const { initNav, addNav } = useNavModel(() => []);

    //退出登录
    const onLogout = async () => {
        if (user.loginType === "account") {
            setUser({ ...user, shopId: "", shopName: "", shopCode: "", token: "" });
            initNav();
            history.push("/login");
            await loginServiceAuth2.Logout();
            await loginServiceAuth2.recordAppLogoutInfo(CLIENT_APP_CODE, user.userCode ?? "");
            await sessionStorage.clear();

        } else {
            closeWebPage();
        }

    };

    const onClearCache = () => {
        initNav()
    }
    const onChangeUser = () => {
        curentUser === '' ? setCurentUser(user.userName) : setCurentUser('');
        onClearCache()
    }
    // 菜单项
    const HeaderMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onClearCache}>关闭所有标签</span>
                </Menu.Item>
                <Menu.Item key="1" icon={<SwapOutlined />}>
                    <span onClick={onChangeUser}>{!!curentUser ? curentUser : '所有人'}</span>
                </Menu.Item>
                {/* <Menu.Divider /> */}
            </Menu>
        )
    }



    return (
        <Header className="layout-section-header">
            {/* 左侧按钮 */}
            <div className="layout-sider-logo">
                <img className="layout-sider-logo-img" src={Logo} alt="管理系统Logo" />
                <span className="one-line">供应商管理系统</span>
            </div>

            {/* <span style={{ fontSize: "22px", fontWeight: "bold", color: "#2db7f5" }}>{user.shopName}</span> */}
            {/* 右侧内容 */}

            <div className="header-right" style={{ paddingRight: "15px", width: "200px" }}>
                {/* 设置 */}
                <Dropdown overlay={HeaderMenu} placement="bottomCenter" trigger={['click']}>
                    <Avatar className="header-right-item config-icon" icon={<FontIcon type="icon-shezhi" />} />
                </Dropdown>



                {/* 登录用户信息 */}
                <span onClick={e => e.preventDefault()} className="header-right-item user-info white-space">
                    <Avatar
                        size="default"
                        icon={<UserOutlined />}
                        className="user-icon"
                    />
                    <span className="account">{user.userName ?? "未获取到"}</span>
                </span>

                {/* 退出登录 */}
                <FontIcon type="icon-tuichu" className="header-right-item logout-icon" onClick={() => onLogout()} />
            </div>
        </Header>
    )
}

export default ScmHeader;
